<template>
  <div>
    <v-card outlined class="pa-3 mt-4" :loading="loading">
      <h6>Online</h6>
      <v-select
        v-model="selectedGateway"
        :items="globalGateways"
        item-title="name"
        item-value="id"
        label="Gateway Padrão"
        hide-details
        outlined
        :disabled="loading || loadingSaveGateway"
      >
        <template v-slot:selection="{ item }">
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </template>
      </v-select>

      <v-alert v-if="errorSaveGateway" type="error" class="mb-3">
        {{ errorSaveGateway }}
      </v-alert>
      <div class="d-flex align-center justify-end mt-1">
        <v-btn
          color="primary"
          @click="saveGateway"
          small
          :disabled="!internalSelectedGateway"
          :loading="loadingSaveGateway"
        >
          <v-icon>mdi-save</v-icon>
          Salvar
        </v-btn>
      </div>
      <v-divider class="my-3"></v-divider>

      <template v-if="selectedGateway === 'MERCADOPAGO'">
        <v-alert type="info" text class="mb-0">
          O Mercado Pago é o gateway exclusivo da plataforma. Não há
          roteamento por forma de pagamento ou valor — PIX e cartão são
          processados no Checkout Pro.
        </v-alert>
      </template>
      <template v-else>
        <h6 class="mb-0">Regras de roteamento</h6>
        <p>
          Configure as regras para determinar o gateway com base no valor e
          forma de pagamento
        </p>
        <v-alert
          v-if="routingGateways.length <= 1"
          type="warning"
          class="mb-3"
        >
          Para criar regras, é necessário ter pelo menos dois gateways válidos
        </v-alert>
        <template v-else>
          <GatewayRulesSettings
            :platform="platform"
            :filteredGateways="routingGateways"
            paymentType="CREDIT_CARD"
            compatible="creditCard"
            :rulesList="rules"
          />
          <GatewayRulesSettings
            :platform="platform"
            :filteredGateways="routingGateways"
            paymentType="PIX"
            compatible="pix"
            :rulesList="rules"
          />
        </template>
      </template>
    </v-card>
  </div>
</template>
<script>
import platformService from "@/services/admin/platform";
import GatewayRulesSettings from "./GatewayRulesSettings.vue";

export default {
  name: "GatewayRules",
  components: {
    GatewayRulesSettings,
  },
  props: {
    gateways: {
      type: Object,
      required: true,
    },
    platform: {
      type: Object,
      required: true,
    },
    gatewaysList: {
      type: Array,
      required: true,
    },
    rules: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loadingSaveGateway: false,
      errorSaveGateway: null,
      internalSelectedGateway: null,
    };
  },
  methods: {
    async saveGateway() {
      this.loadingSaveGateway = true;
      try {
        await platformService.updateGateway(this.platform.id, "paymentConfig", {
          paymentIntegration: this.selectedGateway,
        });
        this.internalSelectedGateway = this.selectedGateway;
        if (this.selectedGateway === "MERCADOPAGO") {
          this.$emit("rules-cleared");
        }
      } catch (error) {
        this.errorSaveGateway = error.message || "Erro ao salvar gateway";
      } finally {
        this.loadingSaveGateway = false;
      }
    },
  },
  computed: {
    filteredGateways() {
      return this.gatewaysList.filter(
        (gateway) => !gateway.underDevelopment && gateway.valid
      );
    },
    routingGateways() {
      return this.filteredGateways.filter(
        (gateway) => gateway.supportsRouting !== false
      );
    },
    globalGateways() {
      return this.filteredGateways.filter(
        (gateway) => gateway.compatible.pix && gateway.compatible.creditCard
      );
    },
    selectedGateway: {
      get() {
        return (
          this.internalSelectedGateway ||
          this.gateways?.paymentConfig?.paymentIntegration ||
          this.gatewaysList[1].id
        );
      },
      set(value) {
        this.internalSelectedGateway = value;
      },
    },
  },
};
</script>
